<template>
  <div class="upload">
    <el-input class="input" :value="fileUrl" placeholder="文件Url链接..." />
    <el-upload class="upload_file" action=""
      accept=".doc,.docx,.xls,.xlsx,.pdf,.ppt,.pptx,.zip,.rar,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/*"
      :before-upload="onUploadFile">
      <el-button size="small" type="primary">{{ start ? '正在上传...' : '点击上传' }}</el-button>
      <el-progress v-if="progress" class="progress" :percentage="progress"></el-progress>
    </el-upload>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as qiniu from 'qiniu-js'
import { delQnFile } from '@/service/api'
import MIME_TYPE from '@/config/mimeType'
import randomString from '@/utils/randomString'

export default {
  name: 'FileUpload',
  props: {
    fileUrl: {
      type: String,
      default: ''
    },
    keyName: {
      type: String,
      default: randomString(16)
    },
    limitSize: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      progress: null,
      start: false
    }
  },
  computed: {
    ...mapState('app', [
      'qnUptoken'
    ])
  },
  methods: {
    async onUploadFile (file) {
      const fileSize = file.size / 1024 / 1024
      const limitSize = this.limitSize ? this.limitSize / 1024 : 5
      console.log('fileSize:', fileSize)
      console.log('limitSize:', limitSize)
      if (fileSize >= limitSize) {
        this.$alert(`上传文件大小不能超过${limitSize}M`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }

      this.start = true
      const fileSuffix = (Object.keys(MIME_TYPE).find(k => MIME_TYPE[k] === file.type)) || 'zip'
      const key = this.keyName + '.' + fileSuffix
      const token = this.qnUptoken.obj
      const config = {
        // 是否使用 cdn 加速域名
        useCdnDomain: true,
        // 上传自动重试次数
        retryCount: 5,
        // 选择上传域名区域
        region: qiniu.region.z2
      }
      const putExtra = {
        // 文件的原文件名
        fname: "",
        // 用来放置自定义变量
        params: {},
        // 用来限制上传文件类型，为 null 时表示不对文件类型限制,限制类型放到数组里
        mimeType: null
      }
      const next = _res => {
        this.progress = _res.total.percent.toFixed(0) * 1
      }
      const complete = _res => {
        this.start = false
        this.progress = null
        const url = this.qnUptoken.domain + '/' + _res.key
        this.$emit('setFileKey', url)
      }
      const error = _err => {
        console.log('err:', _err)
      }

      const keyList = this.fileUrl.split(this.qnUptoken.domain + '/')
      if (keyList.length > 0 && keyList[1]) {
        // await delQnFile({ key: keyList[1] })
        console.log('key:', key)
        await delQnFile({ key })
      }

      const observable = qiniu.upload(file, key, token, putExtra, config)
      observable.subscribe({
        next,
        error,
        complete
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
